module.exports = __webpack_public_path__ + "img/85.da313e6f.png";